var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.sideTab.emails = !vm.sideTab.emails\">Close</md-button></div><div layout=\"row\"><div layout=\"column\"><h3>Add New Email</h3><p>Email Type </p><select ng-model=\"vm.nwEmail.emailType\" class=\"form-control\"><option value=\"admin\">Admin</option><option value=\"additional\">Additional</option></select><br/><select ng-model=\"vm.nwEmail.isPrimary\" class=\"form-control\"><option value=\"true\">Primary Email </option><option value=\"false\">Alternative Email</option></select><p>Email Address </p><input ng-model=\"vm.nwEmail.emailAddress\" class=\"form-control\"/><md-button ng-click=\"vm.addEmail()\" class=\"md-raised\">Add Email </md-button></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/settings/tabs/addEmail.jade
// module id = 173
// module chunks = 0